"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module banner
 */

module.exports = function (config, get, post) {

	/**
	 * [warning description]
	 * @param  {[type]} min_time [description]
	 * @param  {[type]} max_time [description]
	 * @return {[type]}          [description]
	 */
	function warning(min_time, max_time) {
		return post("/v2/banner/warning", {
			min_time: min_time,
			max_time: max_time
		});
	}

	/**
	 * Sends out a warning saying that the VButton has been disconnected
	 * @return {Promise} Resolves if the banner was created successfully
	 */
	function warning_device_disconnected() {
		return post("/v2/banner/warning/device/disconnected", {});
	}

	/**
	 * Sends out a warning saying that the VButton has been disconnected
	 * @return {Promise} Resolves if the banner was created successfully
	 */
	function warning_device_connected() {
		return post("/v2/banner/warning/device/connected", {});
	}

	/**
	 * Sends out a warning saying that the VButton is low on battery
	 * @param  {Number}  battery The battery level of the VButton
	 * @return {Promise}         Resolves if the banner was created successfully
	 */
	function warning_device_battery(battery) {
		return post("/v2/banner/warning/device/battery", {
			battery: battery
		});
	}

	/**
	* Sends out a banners acknowledging that the user has changed the battery.
	* @return {Promise} Resolves if the banner was created successfully.
	*/
	function warning_device_batterychanged() {
		return post("/v2/banner/warning/device/batterychanged", {});
	}

	/** Sends out a warning about the state of the wandering.  The states are:
	0 - not wandering, 1 - wandering, 2 - acknowledged **/
	function warning_device_wandering(wandering) {
		return post("/v2/banner/warning/device/wandering", {
			wandering: wandering
		});
	}

	function warning_reminder_pending(reminder) {
		return post("/v2/banner/warning/reminder/pending", {
			reminder: reminder
		});
	}

	/**
	 * [urgency description]
	 * @param  {[type]} who [description]
	 * @return {[type]}     [description]
	 */
	function urgency(who, reason) {
		return post("/v2/banner/urgency", {
			who: who,
			reason: reason
		});
	}

	/**
	 * [urgency_accepted description]
	 * @param  {[type]} who [description]
	 * @return {[type]}     [description]
	 */
	function urgency_accepted(who, reason) {
		return post("/v2/banner/urgency/accepted", {
			who: who,
			reason: reason
		});
	}

	/**
	 * [urgency_cancelled description]
	 * @return {[type]} [description]
	 */
	function urgency_cancelled(reason) {
		return post("/v2/banner/urgency/cancelled", {
			reason: reason
		});
	}

	/**
	 * [list description]
	 * @return {[type]} [description]
	 */
	function list() {
		return get("/v2/banner/list", {});
	}

	/**
	 * [read description]
	 * @param  {[type]} from [description]
	 * @param  {[type]} type [description]
	 * @return {[type]}      [description]
	 */
	function read(from, type, group) {
		return post("/v2/banner/read", {
			from: from,
			type: type,
			group: group
		});
	}

	function manager_warning_device_battery(battery) {
		return post("/v2/banner/manager/warning/device/battery", {
			battery: battery
		});
	}

	/**
	* Sends out a banners acknowledging that the user has changed the battery.
	* @return {Promise} Resolves if the banner was created successfully.
	*/
	function manager_warning_device_batterychanged() {
		return post("/v2/banner/manager/warning/device/batterychanged", {});
	}


	warning.device = {
		disconnected: warning_device_disconnected,
		connected: warning_device_connected,
		battery: warning_device_battery,
		wandering: warning_device_wandering,
		batterychanged: warning_device_batterychanged,
		manager: {
			battery: manager_warning_device_battery,
			batterychanged: manager_warning_device_batterychanged
		}
	};

	warning.reminder = {
		pending: warning_reminder_pending
	};

	return {
		warning: warning,
		urgency: urgency,
		urgency_accepted: urgency_accepted,
		urgency_cancelled: urgency_cancelled,
		list: list,
		read: read
	};
};
